import { PRILPriority, PRILStatus } from "@/constants/request/PRILConstants";

export default class EditPRILPayload {
  isHidden: boolean | null = true;
  priority: PRILPriority | null = null;
  letterType: number | null = null;
  status: PRILStatus | null = null;
  assigneeId: number | null = null;
  locationId: number | null = null;
  managerComment: string | null = null;
  dueDate: Date | null = null;
  amount: number | null = null;
}
